import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

/**
 * Injects admin-controlled global scripts:
 *   - Google Analytics 4 gtag snippet (when `google_analytics_id` is set)
 *   - `custom_head_code` (raw HTML — trusted, admin-only source)
 *   - `custom_body_code` (appended to <body>)
 *
 * Mounted once in App.jsx so it fires on every route.
 */
export default function GlobalSiteScripts() {
    const { settings, loaded } = useSettings();
    if (!loaded) return null;

    const ga = (settings.google_analytics_id || "").trim();
    const fb = (settings.meta_pixel_id || "").trim();
    const head = (settings.custom_head_code || "").trim();
    const body = (settings.custom_body_code || "").trim();

    return (
        <>
            {ga && (
                <Helmet>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga}`}></script>
                    <script>{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${ga}');
                    `}</script>
                </Helmet>
            )}
            {fb && (
                <Helmet>
                    <script>{`
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${fb}');
fbq('track', 'PageView');
                    `}</script>
                    <noscript>{`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${fb}&ev=PageView&noscript=1" />`}</noscript>
                </Helmet>
            )}
            {head && (
                <Helmet>
                    <script>{`/* custom head code is injected via innerHTML below */`}</script>
                </Helmet>
            )}
            {/* Raw HTML injection for custom code (dangerouslySetInnerHTML for <script>, <meta>, <link> tags). */}
            {head && (
                <div
                    data-testid="custom-head-code"
                    style={{ display: "none" }}
                    dangerouslySetInnerHTML={{ __html: head }}
                />
            )}
            {body && (
                <div
                    data-testid="custom-body-code"
                    style={{ display: "none" }}
                    dangerouslySetInnerHTML={{ __html: body }}
                />
            )}
        </>
    );
}
